"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CabecalhoCard = void 0;
var LftIconBase_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftIconBase"));
var LftTypography_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftTypography"));
var react_1 = __importDefault(require("react"));
var cabecalho_card_styles_1 = require("./cabecalho-card.styles");
/* Foi adicionado um parametro para poder passar um icone do Sava pois o ícone usado no card de exercícios não tem no Lift
Após a inclusão ou após a troca do ícone do exercícios deixar somente o icone do Lift */
var CabecalhoCard = function (_a) {
    var iconeLift = _a.iconeLift, iconeSava = _a.iconeSava, titulo = _a.titulo;
    return (react_1.default.createElement(cabecalho_card_styles_1.CabecalhoCardStyled, null,
        react_1.default.createElement(cabecalho_card_styles_1.IconeCabecalhoCardStyled, { "data-testid": "icone-cabecalho-card" },
            iconeLift && react_1.default.createElement(LftIconBase_1.default, { icon: iconeLift, size: "md", bgColor: true }),
            !iconeLift && iconeSava && iconeSava),
        react_1.default.createElement(cabecalho_card_styles_1.TituloCabecalhoCardStyled, { "data-testid": "titulo-cabecalho-card" },
            react_1.default.createElement(LftTypography_1.default, { component: "title", variant: "h4", size: "small" }, titulo))));
};
exports.CabecalhoCard = CabecalhoCard;
